import { useState } from 'react';

interface ISelectBox {
  id: string;
  label: string;
  value: string;
  onChange: (fieldName: string, value: string | number) => void;
  showLabel?: boolean;
  required?: boolean;
  hidden?: boolean;
}

export const SelectBox = ({
  id,
  label,
  onChange,
  showLabel = false,
}: ISelectBox): JSX.Element => {
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked((e.target as HTMLInputElement).checked);
    let v;
    if (!isChecked) v = '0';
    else v = '1';
    onChange(e.target.value, v);
  };

  return (
    <div className="font-bold gap-4 pb-5 sm:pb-4 flex justify-between items-center">
      {showLabel && <label htmlFor={id}>{label}</label>}

      <input
        id={id}
        type="checkbox"
        className={
          'span:hover w-4 h-4 text-red-600 bg-gray-100 border-gray-300 rounded  dark:focus:ring-red-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600'
        }
        value={id}
        onChange={handleCheckboxChange}
        checked={isChecked}
      />
    </div>
  );
};
